<template>
  <router-link :to="to">
    <span class="flex justify-center ml-4 font-semibold items-center py-2 px-4 border border-transparent text-sm md:text-base rounded-md text-white bg-big-stone hover:bg-blumine focus:outline-none focus:ring-2 focus:ring-sail focus:shadow-outline-sail active:bg-blumine transition duration-150 ease-in-out">
      <span class="material-icons mr-2">add_circle</span>
      <span>{{ title }}</span>
    </span>
  </router-link>
</template>

<script>

export default {
  props: ['to', 'title'],
}
</script>